import * as propertyTypes from "../property_types.js"

export class UiCheckboxProps extends propertyTypes.AppBaseComponentProps {

    getMetadata(): propertyTypes.BaseProperty[] {
        return super.getMetadata();
    }
}